<template>
  <router-view />
</template>

<script>
export default {
  name: 'DemoShell'
}
</script>
